import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevBlack.png"
import DeleteImg from "../../img/Delete.png"
import axios from "axios";
import MenuEx from "../../img/naga.png"
import EndPng from "../../img/End.png"
import { useCookies } from 'react-cookie';
import EventCompo from "./EventCompo";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        Nothing:styled.div`
            width:100%;
            height:56px;
        `,
        ContentWrap:styled.div`
            width:90%;
            height:372px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
            margin-top:20px;
        `,
            EndWrap:styled.div`
                width:100%;
                height:187px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:column;
            `,
                EndImg:styled.img`
                    width:120px;
                    height:120px;
                    object-fit: contain;
                `,
                EndTitle:styled.p`
                    font-size:18px;
                    font-weight:600;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                `,
                EndText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#767676;
                    margin:0px;
                    font-family:'PreFont';
                `,

            ExplainBox:styled.div`
                width:100%;
                height:auto;
                margin-bottom:20px;
                display:flex;
                justify-content:center;
                align-items:flex-start;
                flex-direction:column;
            `,
                ExplainTitle:styled.p`
                    font-size:18px;
                    font-weight:500;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                `,
                ExplainText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#767676;
                    margin:0px;
                    font-family:'PreFont';
                `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
            ContentBoxWrap:styled.div`
                width:100%;
                height:145px;
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-direction:column;
            `,
                ContentBoxTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    margin:0px;
                    font-family:'PreFont';
                    color:#111111;
                    letter-spacing:-0.33px;
                `,
            ContentBox:styled.div`
                width:100%;
                height:auto;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                border:1px solid #EDEDED;
                border-radius:10px;
                margin-bottom:10px;
                padding-bottom:5px;
                padding-top:5px;
            `,
                OrderBox:styled.div`
                    width:90%;
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                MenuImg:styled.div`
                    width:80px;
                    height:80px;
                `,
                    Img:styled.img`
                        width:100%;
                        height:100%;
                        border-radius:10px;
                        border:1px solid #787878;
                    `,
                Content:styled.div`
                    width:calc(100% - 87px);
                    height:auto;
                    display:flex;
                    justify-content:space-between;
                    align-items:flex-end;
                    flex-direction:row;
                `,
                    LeftContent:styled.div`
                        width:65%;
                        height:auto;
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-start;
                        flex-direction:column;
                    `,
                    RightContent:styled.div`
                        width:35%;
                        height:100%;
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-end;
                    `,
                        CancelRequestBtn:styled.div`
                            

                            width:52px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #B7B7B7;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                            &:hover{
                                opacity:50%;
                                transition:0.5s;
                            }
                        `,
                            CancelRequestBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#767676;
                                letter-spacing:-0.33px;
                            `,
                        CancelEndBtn:styled.div`
                            width:63px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #2277F6;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            CancelEndBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#2277F6;
                                letter-spacing:-0.33px;
                            `,
                        ContentHText:styled.p`
                            font-size:16px;
                            font-weight:600;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentText:styled.p`
                            font-size:16px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentGrayText:styled.p`
                            font-size:14px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,
                        ContentDateText:styled.p`
                            font-size:12px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,

}
const End=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const [cookies, setCookie] = useCookies(["eventClosed"]);
    const [CallOpen, setCallOpen] = useState(false);

    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)

    const [ApiData, setApiData] = useState([])

    
    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
            const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
        
            setRestaurant_PK(first);
            setTable_PK(second);
        } else {
            console.log("ID 값이 없습니다.");
        }
        console.log(IDcookies["restaurant_id"])
    }, [IDcookies["restaurant_id"]]);


    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    
    const RestaurantCheck = async () => {
        try {
            const response = await axiosInstance.get("orders/order/?table__id="+Table_PK);
            setApiData(response.data.results[0])
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    };

    useEffect(()=>{
        if(Table_PK){
            RestaurantCheck()
        }
    },[Table_PK])



    useEffect(()=>{
        const eventClosed = cookies.eventClosed;
        if(Langcookies["PageLang"] === "KR"){
            if (eventClosed && new Date().getTime() < eventClosed) {
                setCallOpen(false); // 3시간 이내면 이벤트를 숨김
            }else{
                setCallOpen(true)
            }
        }
        // 한국이 아닌 다른 언어의 국가는 네이버 리뷰 이벤트 페이지가 나오지 않음.
            // 3시간 뒤면 사라지는 쿠키가 있고, 이 쿠키가 남아있으면 이벤트 페이지가 나오지 않음.
    }, [])
    const navigate = useNavigate();


    const [OrderQuantity, setOrderQuantity] = useState({
        "KR":"수량",
        "EN":"Quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Menge",
        "RU":"количество"
    })
    

    const [Won, setWon] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })

    const [Title, setTitle] = useState({
        "KR":"주문완료",
        "EN":"Order completed",
        "CN":"订单完成",
        "JP":"注文完了",
        "FR":"Commande terminée",
        "SP":"Pedido completado",
        "GR":"Bestellung abgeschlossen",
        "RU":"Заказ завершен"
    })
    const [OrderComplete, setOrderRequest] = useState({
        "KR":"주문이 완료되었어요",
        "EN":"Your order is complete",
        "CN":"您的订单已完成",
        "JP":"ご注文が完了しました",
        "FR":"Votre commande est terminée",
        "SP":"Tu pedido está completo",
        "GR":"Ihre Bestellung ist abgeschlossen",
        "RU":"Ваш заказ выполнен"
    })
    const [Ready, setReady] = useState({
        "KR":"주문하신 음식을 준비중이에요",
        "EN":"Preparing your food",
        "CN":"正在准备您的食物",
        "JP":"ご注文の料理を準備中です",
        "FR":"Préparation de votre repas",
        "SP":"Preparando tu comida",
        "GR":"Ihr Essen wird zubereitet",
        "RU":"Ваш заказ готовится"
    })
    const [OrderDetails, setOrderDetails] = useState({
        "KR":"주문내역",
        "EN":"Order details",
        "CN":"订单详情",
        "JP":"注文履歴",
        "FR":"Détails de la commande",
        "SP":"Detalles del pedido",
        "GR":"Bestelldetails",
        "RU":"Детали заказа"
    })

    const [Main, setMain] = useState({
        "KR":"메인화면으로 돌아가기",
        "EN":"Back to main screen",
        "CN":"返回主页面",
        "JP":"メイン画面に戻る",
        "FR":"Retour à l'écran principal",
        "SP":"Volver a la pantalla principal",
        "GR":"Zurück zum Hauptbildschirm",
        "RU":"Вернуться на главный экран"
    })

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        
        const yy = String(date.getFullYear()).slice(2);
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");
      
        return `${yy}.${mm}.${dd} ${hh}:${min}`;
      };
    return(
            <Styled.Wrap>
                <EventCompo  CallOpen={CallOpen} setCallOpen={setCallOpen} />
                <Styled.HeaderWrap>
                    <Styled.Header>
                        <Styled.PrevBtn onClick={() => navigate(`/${IDcookies["restaurant_id"]}`)}>
                            <Styled.PrevImg src={Prev}/>
                        </Styled.PrevBtn>
                        <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                        <Styled.PrevBtn />
                    </Styled.Header>
                </Styled.HeaderWrap>
                <Styled.ContentWrap>
                    <Styled.EndWrap>
                        <Styled.EndImg src={EndPng}/>
                        <Styled.EndTitle>{OrderComplete[Langcookies["PageLang"]]}</Styled.EndTitle>
                        <Styled.EndText>{Ready[Langcookies["PageLang"]]}</Styled.EndText>
                    </Styled.EndWrap>
                    <Styled.ContentBoxWrap>
                        <Styled.ContentBoxTitle>{OrderDetails[Langcookies["PageLang"]]}</Styled.ContentBoxTitle>
                        <Styled.ContentBox>
                            {ApiData.length !== 0 ? 
                                <Styled.OrderBox>
                                    <Styled.MenuImg>
                                        <Styled.Img src={`https://zzikgomainapi.co.kr${ApiData.items[0].menu_info.image}`}/>
                                    </Styled.MenuImg>
                                    <Styled.Content>
                                        <Styled.LeftContent>
                                            <Styled.ContentHText>{ApiData.items[0].menu_info.names[Langcookies["PageLang"]]}{ApiData.items.length < 2 ? "":`외 ${ApiData.items.length - 1}개`}</Styled.ContentHText>
                                            <Styled.ContentText>{ApiData.total_costs}{Won[Langcookies["PageLang"]]}</Styled.ContentText>
                                            <Styled.ContentGrayText>{OrderQuantity[Langcookies["PageLang"]]} : {ApiData.items[0].quantity}</Styled.ContentGrayText>
                                        </Styled.LeftContent>
                                        <Styled.RightContent>
                                            
                                            <Styled.ContentDateText>{formatDate(ApiData.ordered_at)}</Styled.ContentDateText>
                                        </Styled.RightContent>
                                    </Styled.Content>
                                </Styled.OrderBox>    
                                :
                                <></>
                            }
                            
                        </Styled.ContentBox>
                    </Styled.ContentBoxWrap>
                    
                </Styled.ContentWrap>
                
                <Styled.Footer>
                    <Styled.CallBtn onClick={()=>{
                        navigate(`/${IDcookies["restaurant_id"]}`)
                    }}>
                        <Styled.BtnText>{Main[Langcookies["PageLang"]]}</Styled.BtnText>
                    </Styled.CallBtn>
                </Styled.Footer>
            </Styled.Wrap>
    )
    
}
export default End